import { ref } from 'vue'
import { apiService } from '../services/api.js'
import { useTelegramData } from './useTelegram.js'

// Глобальное состояние данных профиля
const profileData = ref({
  balance: null,
  exp: null,
  copy: null,
  traderData: null,
  closedPositions: [],
  isLoading: false
})

let updateInterval = null
let visibilityHandler = null

export function useProfileData() {
  const { userData } = useTelegramData()

  const loadProfileData = async () => {
    const userId = userData.value?.id
    if (!userId) {
      return
    }

    profileData.value.isLoading = true

    try {
      const response = await apiService.getUserData(userId)

      if (response.ok && response.data && response.data.user) {
        const user = response.data.user

        // Обновляем баланс
        if (user.balance != null) {
          profileData.value.balance = Number(user.balance) || 0
        }

        // Обновляем опыт
        if (user.exp != null) {
          profileData.value.exp = Math.min(1000, Math.max(0, Number(user.exp) || 0))
        }

        // Обновляем статус copy
        if (user.copy !== undefined) {
          profileData.value.copy = user.copy === 'false' || user.copy === false ? false : true
        }

        // Обновляем закрытые позиции
        if (user.closed_positions !== undefined) {
          profileData.value.closedPositions = user.closed_positions || []
        }

        // Загружаем данные трейдера, если есть trader_id
        if (user.trader_id) {
          try {
            const traderResponse = await apiService.findTrader(userId)
            if (traderResponse.ok && traderResponse.data && traderResponse.data.landing) {
              profileData.value.traderData = traderResponse.data.landing
            }
          } catch (err) {
            console.error('Error loading trader data:', err)
          }
        }
      }
    } catch (error) {
      console.error('Error loading profile data:', error)
    } finally {
      profileData.value.isLoading = false
    }
  }

  const startAutoUpdate = (intervalMs = 30000) => {
    // Загружаем сразу
    loadProfileData()

    // Устанавливаем интервал обновления
    if (updateInterval) {
      clearInterval(updateInterval)
    }

    updateInterval = setInterval(() => {
      loadProfileData()
    }, intervalMs)

    // Добавляем обработчик переключения вкладок
    if (typeof window !== 'undefined' && !visibilityHandler) {
      visibilityHandler = () => {
        // Обновляем данные при возврате на вкладку
        if (!document.hidden) {
          loadProfileData()
        }
      }
      document.addEventListener('visibilitychange', visibilityHandler)
    }
  }

  const stopAutoUpdate = () => {
    if (updateInterval) {
      clearInterval(updateInterval)
      updateInterval = null
    }

    // Удаляем обработчик переключения вкладок
    if (typeof window !== 'undefined' && visibilityHandler) {
      document.removeEventListener('visibilitychange', visibilityHandler)
      visibilityHandler = null
    }
  }

  return {
    profileData,
    loadProfileData,
    startAutoUpdate,
    stopAutoUpdate
  }
}

